module.exports = __webpack_public_path__ + "static/media/code-bg.4bd77061.png";